import { CustomerTokenPurposeEnum } from './types/types';
import { Session } from 'next-auth';
import FinanceError from './errors/finance-error';
import { StatusCodes } from 'http-status-codes';

export function getCustomerTokenKey(customerId: string, fingerprint: string, purpose: CustomerTokenPurposeEnum) {
    return `${customerId}-${fingerprint}-${purpose}`;
}

export function camelCaseToTitleCase(str: string): string {
    if (!str) return str;
    return str
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, substring => substring.toUpperCase())
        .replace(/ +/g, ' ');
}

export function digitsOnly(value: string) {
    return value ? value.replace(/\D/g, '') : '';
}

export function formatNumber({ value, cents = true, options = {} }: { value: number; options?: object; cents?: boolean }) {
    const fractionDigits = value !== 0 ? 2 : 0;
    const opt = {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        ...options
    };
    return Intl.NumberFormat('en-US', opt).format(cents ? value / 100 : value);
}

export function roundDown(num: number, precision: number) {
    const precisionPow = Math.pow(10, precision);
    return Math.floor(num * precisionPow) / precisionPow;
}

export function safeCompanyId(session?: Session, source?: string): string {
    const companyId = session?.user.auditeeCompanyId ?? session?.user.companyId;

    if (!companyId) {
        throw new FinanceError({
            message: `${source} Missing session user company id`,
            statusCode: StatusCodes.BAD_REQUEST
        });
    }

    return companyId;
} // checks if a string is null, undefined, or empty
export function isBlank(string: string | null | undefined) {
    return !string || string.trim().length === 0;
}
